import { Permission } from '../enums';
import { SelectOption } from '../models';

export type IPermission = Omit<SelectOption<Permission>, 'value'>;
export interface IPermissionGroup {
  key: string;
  title: string;
  desc: string;
  view: Permission[];
  hasManage: boolean;
  manage?: Permission[];
  viewSelected?: boolean;
  manageSelected?: boolean;
}
